import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { queryKeys } from '../../lib/queryKeys'
import { getSfdcAccount, getSfdcCsmBulk, getCsmSummary } from '../../apis/sfdc'
import { HAS_US_DATA_SOURCES } from '../../constants/apis'
import type { SfdcAccount, CsmSummary, CsmBulkMap } from '../../types'

export const useSfdcAccount = (
  orgId: string | number | undefined,
  enabled: boolean = true
): UseQueryResult<SfdcAccount> => {
  return useQuery({
    queryKey: queryKeys.sfdc.account(orgId!),
    queryFn: async () => {
      const { data } = await getSfdcAccount(orgId!)
      return data
    },
    enabled: !!orgId && enabled && HAS_US_DATA_SOURCES,
    staleTime: 5 * 60 * 1000
  })
}

export const useSfdcCsmBulk = (
  orgIds: string[]
): UseQueryResult<CsmBulkMap> => {
  return useQuery({
    queryKey: queryKeys.sfdc.csmBulk(orgIds),
    queryFn: async () => {
      const { data } = await getSfdcCsmBulk(orgIds)
      return data
    },
    enabled: orgIds.length > 0 && HAS_US_DATA_SOURCES,
    staleTime: 5 * 60 * 1000
  })
}

export const useCsmSummary = (): UseQueryResult<CsmSummary[]> => {
  return useQuery({
    queryKey: queryKeys.sfdc.csmSummary(),
    queryFn: async () => {
      const { data } = await getCsmSummary()
      return data
    },
    enabled: HAS_US_DATA_SOURCES,
    staleTime: 5 * 60 * 1000
  })
}
